import { render, staticRenderFns } from "./PaypalCard.vue?vue&type=template&id=0b082fb8"
import script from "./PaypalCard.vue?vue&type=script&lang=js"
export * from "./PaypalCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports